import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "collapsible-card",
  templateUrl: "collapsible-card.component.html",
})
export class CollapsibleCardComponent {
  @Input()
  headerTitle: string = "";

  @Input()
  fullWidthHeader: boolean = true;

  // Additional icon support (e.g., edit icon, settings icon, etc.)
  @Input()
  additionalIcon?: string;

  @Input()
  showAdditionalIcon?: boolean = true;

  @Output()
  additionalIconClick = new EventEmitter<void>();

  isCollapsed: boolean = true;

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  onAdditionalIconClick(): void {
    this.additionalIconClick.emit();
  }

  get iconName(): string {
    return this.isCollapsed ? "ios-arrow-down" : "ios-arrow-up";
  }
}



// WEBPACK FOOTER //
// ./src/components/collapsible-card/collapsible-card.component.ts